var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import Sticky from "react-sticky-el";
import Form from "@irati/ui/src/Form";
import { Hr } from "@irati/ui/src/Layout";
import authentication from "@irati/auth";
import connect from "@irati/store/connect";
import { H2, H4 } from "@irati/ui/src/Headings";
import { injectIntl } from "@irati/utils/lang";
import Recipients from "@irati-web/reward/src/components/Recipients";
import Card from "@irati/ui/src/Layout/Card";
import { Para } from "@irati/ui/src/Labels";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import history from "@irati/utils/history";
import { sendCreditToUser } from "@irati/wallet/graph/wallet";
import Flex from "@irati/ui/src/Flex";
import { getCentValue } from "@irati/utils/currency/formatCurrency";
import Sidebar from "../../components/Sidebar";
import Wallet from "../../images/wallet_badge.svg";
var StyledForm = styled(Form)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 30px;\n"], ["\n  margin-top: 30px;\n"])));
var Image = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 50px;\n  height: 50px;\n  margin-right: 15px;\n  ", "\n"], ["\n  width: 50px;\n  height: 50px;\n  margin-right: 15px;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 80px;\n    height: 80px;\n    margin-right: 20px;\n  "], ["\n    width: 80px;\n    height: 80px;\n    margin-right: 20px;\n  "])));
});
var SendCreditContainer = /** @class */ (function (_super) {
    __extends(SendCreditContainer, _super);
    function SendCreditContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            amount: 0,
            recipients: [],
            load: null,
            error: null
        };
        _this.componentDidMount = function () {
            _this.props.getWallet();
        };
        _this.submit = function () {
            var _a = _this.props, wallet = _a.wallet, getWallet = _a.getWallet;
            var _b = _this.state, recipients = _b.recipients, amountInCents = _b.amount;
            var senderId = authentication.user().uuid;
            var currency = wallet.currency;
            var amount = getCentValue(currency, amountInCents);
            if (recipients.length > 0 && amount && wallet.currency) {
                _this.setState({
                    load: sendCreditToUser(senderId, recipients[0].uuid, amount, currency)
                        .then(function () {
                        return getWallet().then(function () {
                            history.push({ pathname: "/wallet", state: { recipient: recipients[0], amount: amount } });
                        });
                    })
                        .catch(function (err) { return _this.setState({ error: err.message }); })
                });
            }
        };
        _this.setRecipients = function (recipients) {
            _this.setState({ recipients: recipients });
        };
        _this.handleChangeAmount = function (value) { return _this.setState({ amount: value }); };
        return _this;
    }
    SendCreditContainer.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, formatMessage = _a.formatMessage, wallet = _a.wallet;
        var _b = this.state, amount = _b.amount, recipients = _b.recipients, load = _b.load, error = _b.error;
        return (React.createElement(StyledForm, null,
            React.createElement(Col, { md: 8, sm: 12 },
                React.createElement(Card, { large: true },
                    React.createElement(Row, null,
                        React.createElement(Flex, { alignItems: "center" },
                            React.createElement(Image, { src: Wallet, alt: "send-credit-image" }),
                            React.createElement(H2, null, formatMessage({ id: "wallet.sendCredit.title" }))),
                        React.createElement(Hr, { large: true }),
                        React.createElement(Para, null, formatMessage({ id: "wallet.sendCredit.desc.text" })),
                        React.createElement(H4, { small: true }, formatMessage({ id: "wallet.sendCredit.desc.title" }))),
                    React.createElement(Recipients, { allowMultipleRecipients: false, recipients: recipients, setRecipients: this.setRecipients }))),
            React.createElement(Col, { md: 4, sm: 12 }, isMobile ? (React.createElement(Sidebar, { wallet: wallet, amount: amount, recipients: recipients, load: load, error: error, onChange: this.handleChangeAmount, onSubmit: this.submit })) : (React.createElement(Sticky, { stickyStyle: { marginTop: "20px" } },
                React.createElement(Sidebar, { wallet: wallet, amount: amount, recipients: recipients, load: load, error: error, onChange: this.handleChangeAmount, onSubmit: this.submit }))))));
    };
    return SendCreditContainer;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq, wallet = _a.wallet;
    return ({
        isMobile: mq.lessThan.md,
        wallet: wallet
    });
};
var mapDispatchToProps = function (dispatch) {
    return {
        getWallet: function () { return dispatch(WalletActions.get()); }
    };
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SendCreditContainer));
var templateObject_1, templateObject_2, templateObject_3;
